import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { TransferNewSearchCrumbs } from 'subscription/constants/breadcrumb';
import ActionsList from './actions';
import PersonSearch from 'shell/components/shared/person-search';

const TransferNewSearch = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={TransferNewSearchCrumbs} />
      <PersonSearch
        pathname="/iscrizioni/aire-trasferimento-nuova/trasferimento"
        action={ActionsList}
        addedTitle="- Iscrizione AIRE per trasferimento - Nuova famiglia"
        isAire
        isNationalSearch
      />
    </Fragment>
  );
};

TransferNewSearch.displayName = 'Transfer New Search page component';

export default TransferNewSearch;
